import { render, staticRenderFns } from "./AddDeclarationsToInvoice.vue?vue&type=template&id=f133f0b8&"
import script from "./AddDeclarationsToInvoice.vue?vue&type=script&lang=js&"
export * from "./AddDeclarationsToInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports